import type { NMPLocale } from "@borealis/locale-common";
import { CurrencyCode, formatCurrency } from "@borealis/number-format";

import { i18n } from "@lingui/core";
import type { RecommerceAd } from "../types";

type AdPriceProps = {
	ad: RecommerceAd;
	className?: string;
};

export function AdPrice(props: AdPriceProps) {
	const { ad, className = "" } = props;

	const hasPrice = ad.price && ad.price.amount > 0 && ad.price.currency_code;

	const priceOrTradeType = hasPrice
		? formatCurrency(ad.price.amount, i18n.locale as NMPLocale, ad.price.currency_code as CurrencyCode)
		: ad.trade_type;

	if (!priceOrTradeType) {
		return null;
	}

	return (
		<div className={`${className} text-m space-x-12 font-bold whitespace-nowrap`}>
			<span>{priceOrTradeType}</span>
		</div>
	);
}
